import React, { useEffect, useRef } from 'react'

export default function Loading() {

  return (
    <div aria-label="loading" className='self-center'>
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div> 
    </div>
  )
}
